module.exports = __webpack_public_path__ + "static/media/lullascape-3.45634ffc.jpg";